import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dropdownPipe',
})
export class DropdownPipe implements PipeTransform {
  transform(
    value: any,
    args: { dropdownList: any[]; fromCol: string; toCol: string }
  ): any {
    const { dropdownList, fromCol, toCol } = args;
    const result = dropdownList.find((item) => {
      if (typeof item[fromCol] !== typeof value) {
        // tslint:disable-next-line: triple-equals
        return item[fromCol] == value;
      } else {
        return item[fromCol] === value;
      }
    });
    if (result) {
      return result[toCol];
    }
    return '';
  }
}
